<template>
    <div class="dynamic-form">
        <loader class="panel-loader" v-if="!isDataLoaded"></loader>
        <form @submit="handleSubmission">
            <div class="dynamic-form-body" v-if="isDataLoaded">
                <formly-form-flex :form="form" :fields="fields" :model="model" ref="formBody"></formly-form-flex>
            </div>
            <div v-if="errors.length" class="alert alert-danger">
                <div class="errors" v-for="error in errors">{{error}}</div>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from 'axios'
    import querystring from 'querystring'
    import Loader from '@/components/Loader'

    export default {
        props: ['formapi', 'id', 'parentid', 'formCallback'],
        name: 'dynamicForm',
        data () {
            return {
                errors: [],
                form: {},
                formvalues: null,
                fields: null,
                saveapi: null
            }
        },
        computed: {
            isDataLoaded: function () {
                return (this.formvalues !== null) && (this.fields !== null)
            },
            model () {
                return this.$deepModel(this.formvalues || {})
            }
        },
        methods: {
            getData: function () {
                let self = this
                return axios.post(this.formapi, querystring.stringify({id: this.id, parentid: this.parentid}), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                    .then(function (response) {
                        self.formvalues = response.data.values
                        self.fields = response.data.fields
                        self.saveapi = response.data.saveapi
                    })
            },
            handleSubmission: function (e) {
                e.preventDefault()

                const self = this

                return this.$refs.formBody.validate()
                    .then(function () {
                        self.errors = false
                        return axios.post(self.saveapi, querystring.stringify({fields: JSON.stringify(self.formvalues)}), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                            .then(function (response) {
                                if (response.data.result) {
                                    self.formvalues = response.data.fields

                                    if (typeof self.formCallback === 'function') {
                                        self.formCallback(response.data)
                                    }
                                } else {
                                    self.formvalues = response.data.fields
                                    let errors = []
                                    for (let error in response.data.errors) {
                                        for (let errorMessage in response.data.errors[error]) {
                                            errors[errors.length] = 'Error in ' + error + ': ' + response.data.errors[error][errorMessage]
                                        }
                                    }
                                    self.errors = errors
                                }
                            })
                    }, function (e) {})
            }
        },
        created () {
            if (this.formapi !== null) {
                this.getData()
            }
        },
        components: { Loader }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// DynamicForm.vue?4ecbbdb1